import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { ROUTES } from '../constants'
import { Box, CircularProgress } from '@mui/material'

/**
 * Composant pour protéger les routes d'administration
 * @param {Object} props - Props du composant
 * @param {React.ComponentType} props.component - Composant à rendre si administrateur
 */
const AdminRoute = ({ component: Component }) => {
  const navigate = useNavigate()
  const { isAuthenticated, user, isLoadingUser } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ROUTES.LOGIN)
    } else if (!isLoadingUser && user && !user.is_admin) {
      navigate(ROUTES.HOME)
    }
  }, [isAuthenticated, user, isLoadingUser, navigate])

  if (isLoadingUser || (!user && isAuthenticated)) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  return isAuthenticated && user && user.is_admin ? <Component /> : null
}

export default AdminRoute
